import { create, type StoreApi } from 'zustand'
import { OfferButtonStore } from './types'

const THIRTY_DAYS = 1000 * 60 * 60 * 24 * 30

const hasExpired = (timestamp: number) => Date.now() - timestamp > THIRTY_DAYS

const getStoredTimestamp = (storageKey: string) => {
  const stored = localStorage.getItem(storageKey)
  return stored ? parseInt(stored) : null
}

export const createButtonStore = (modal_id: string) =>
  create<OfferButtonStore>((set) => {
    const STORAGE_KEY = `${modal_id}_closed_at`
    const stored = getStoredTimestamp(modal_id)
    const dismissed = stored !== null && !hasExpired(stored)

    return {
      isOpen: false,
      isDismissed: dismissed,

      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false }),

      setDismissed: (value) => set({ isDismissed: value }),

      dismiss: () => {
        localStorage.setItem(STORAGE_KEY, Date.now().toString())
        set({ isDismissed: true })
      },

      checkDismissed: () => {
        const stored = getStoredTimestamp(STORAGE_KEY)
        if (stored && !hasExpired(stored)) {
          set({ isDismissed: true })
        } else {
          set({ isDismissed: false })
        }
      },
    }
  })

const createOfferButtonStore = createButtonStore('promotional_offer')

export const useOfferButtonStore = () => createOfferButtonStore()
